import { render, staticRenderFns } from "./CreateAnswer.vue?vue&type=template&id=0a98326d&scoped=true&"
import script from "./CreateAnswer.vue?vue&type=script&lang=js&"
export * from "./CreateAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98326d",
  null
  
)

export default component.exports